// extracted by mini-css-extract-plugin
module.exports = {"articleWrapper":"projects_articleWrapper__1JLHL","west":"projects_west__3VYMy","east":"projects_east__2syMc"};